module.exports = __webpack_public_path__ + "img/About_Freelancers_DARK-05.9217ab4.svg";